import React,{useContext} from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import logoimg from '../../assets/images/kplot-logo.png'
import { FaRegUser } from "react-icons/fa";
import { useSearch } from "../searchContext/SearchContext"; // Import Context
import { useFilter } from "../filterContext/filterContext";
import { LoginPopupContext } from '../loginpopup/LoginPopupContext';
import axios from 'axios';
const path = "/keralaplots/";

function Nav({ onNavClick }) {
    const location = useLocation();
    const { setSearchQueryNew } = useSearch();
    const { saveFilterData } = useFilter();
    const [isPopupVisible, setIsPopupVisible] = useContext(LoginPopupContext);

    const isActiveProperty = () => {
        return location.pathname.includes(`/properties`) || location.pathname.includes(`/innerProperty`) ;
    };

    const handleContext = () => {
        setSearchQueryNew(''); 
        const filterData = {
            propertyType: [],  // Only save the selected property type as the first value in the array
            purpose: "",  // Ensure purpose is either set or empty
            selectedDistrict: "",  // Ensure district is either set or empty
            selectedTown: ""  // Ensure town is either set or empty
        };
        saveFilterData(filterData);
    };

    const fetchStoressessionvalues = async (loginId) => {
        try {
            const response = await axios.post(
                'https://keralaplots.com/Official/create_session.php',
                { loginId: loginId },
                {
                    headers: {
                        'Content-Type': 'application/json', // Ensure the server knows you're sending JSON
                    },
                    withCredentials: true, // Include cookies in the request
                }
            );
            console.log(response.data);  // Log the response from the server
        } catch (error) {
            //toast.error(error.response?.data?.error || "An error occurred. Please try again.");
        }
    };

  return (
    <>
        <nav>
            <div className="container">
                <div className="navMain">
                    <div className="navCol1">
                        <Link to={`${path}`} className="navLogo">
                            <img src={logoimg} alt="" />
                        </Link>
                    </div>
                    <div className="navCol2">
                        <div className="navLink">
                            <ul>
                                <li>
                                    <NavLink to={`${path}`} end className={({ isActive }) => (isActive ? 'navLinkActive' : '')} onClick={handleContext}>Home</NavLink>
                                </li>
                                <li>
                                    <NavLink to={`${path}properties`} className={() => (isActiveProperty() ? 'navLinkActive' : '')} onClick={handleContext}>Properties</NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="navCol3">
                        <div className="navProfile">
                            {/* <NavLink to="https://keralaplots.com/keralaplots/postProperty/post-basic-info.html?id=0" target='_blank' className="navPostproperty">Post Property</NavLink> */}
                            
                            <a 
                            href="#" 
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default link behavior
                                const Tokenval = localStorage.getItem("jwtToken"); 
                                if (!Tokenval) {
                                    localStorage.setItem("previousAction", JSON.stringify({
                                        action: "PostProperty",
                                        data: {
                                            url: "https://keralaplots.com/keralaplots/postProperty/post-basic-info.html?id=0"
                                        }
                                    }));
                                    setIsPopupVisible(true); // Show login popup
                                } else {
                                    fetchStoressessionvalues(localStorage.getItem("login_id"));
                                    window.open("https://keralaplots.com/keralaplots/postProperty/post-basic-info.html?id=0", "_blank");
                                }
                            }} 
                            className="navPostproperty"
                        >
                            Post Property
                        </a>
                        <div className="navBar" onClick={onNavClick}>
                                <div className="navBarBox">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                                <div className="navBarBoxProfile">
                                    <FaRegUser />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </>
  );
}

export default Nav;
